import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import { RebelTitle, RebelSubtitle } from '../../../styles/rebel-experiences';
import AgendaConfigList from './agenda-config-list';

const AgendaConfig = (props) => {
    return (
        <PageContainer>
            <Row>
                <Col style={{textAlign: "center"}}>
                    <RebelTitle>
                        Agenda Config
                    </RebelTitle>
                    <RebelSubtitle>
                        Manage Locations and Activities for Client Agendas
                    </RebelSubtitle>
                </Col>
            </Row>
            <AgendaConfigList />
        </PageContainer>
    )
}

export default AgendaConfig;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;
